export const en = {
    from: 'from',
    more_details: 'Choose room',
    per_night: 'per night',
    special_project_ya_travel: 'Ya.Travel special project',
};
